import classNames from 'classnames'

import { Button } from 'core-components/library/button'

import styles from './PageControl.module.scss'

interface IProps {
  pages: number[]
  changePage: (newPage: number) => void
  wip?: boolean
  currentPage: number
  showNext: boolean
  startPage: number
}

export const PageControl = ({
  pages,
  changePage,
  wip,
  currentPage,
  showNext,
  startPage,
}: IProps) => {
  let visible
  if (pages.length < 5) {
    visible = pages

    if (showNext) {
      visible = [...pages, pages.length + 1]
    }
  } else {
    visible = [
      pages[0],
      -1,
      pages[pages.length - 3],
      pages[pages.length - 2],
      pages[pages.length - 1],
    ]

    if (showNext) {
      visible = [pages[0], -1, pages[pages.length - 2], pages[pages.length - 1], pages.length + 1]
    }
  }

  return (
    <>
      {visible.map((page, i) => {
        if (page > 0) {
          return (
            <Button
              key={i}
              disabled={wip}
              onClick={() => {
                const delta = startPage === 0 ? 1 : 0
                changePage(page - delta)
              }}
              className={classNames(
                styles.pageItem,
                page === currentPage ? styles['pageItem--selected'] : ''
              )}
              variant={'text'}
            >
              {page}
            </Button>
          )
        }
        return (
          <Button key={i} className={styles.pageItem} variant={'text'} disabled>
            …
          </Button>
        )
      })}
    </>
  )
}
